module.exports = __webpack_public_path__ + "img/outboundOrder.43ac9a4c.svg";